/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useEffect } from "react";
import ArtworkAlert from "./ArtworkAlert.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { redirectTo } from "common/utils/browser";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { useDtfStore } from "./store";
import { cn } from "tailwind-variants";
import "./ArtworkError.scss";

export default function ArtworkError({ artwork = null, currentStore = null, ...restProps }) {
  const dtfStore = useDtfStore();

  function showNewGangSheetErrorMessage() {
    // @ts-expect-error TS(4111): Property 'showNewGangSheetErrorMessage' comes from... Remove this comment to see the full error message
    return dtfStore.showNewGangSheetErrorMessage;
  }

  function dpiInstructionsUrl() {
    // @ts-expect-error TS(4111): Property 'dpiInstructionsUrl' comes from an index ... Remove this comment to see the full error message
    return dtfStore.dpiInstructionsUrl;
  }

  function gangSheetArtworkProductLink() {
    // @ts-expect-error TS(4111): Property 'gangSheetArtworkProductLink' comes from ... Remove this comment to see the full error message
    return dtfStore.gangSheetArtworkProductLink;
  }

  function showStepsUI() {
    // @ts-expect-error TS(4111): Property 'showStepsUI' comes from an index signatu... Remove this comment to see the full error message
    return dtfStore.showStepsUI;
  }

  function validationError() {
    // @ts-expect-error TS(2339): Property 'errorMessage' does not exist on type 'ne... Remove this comment to see the full error message
    return artwork?.errorMessage;
  }

  function heightError() {
    return validationError() === "gang_sheet_height_error";
  }

  function widthError() {
    return validationError() === "gang_sheet_width_error";
  }

  function dimensionErrorMessage() {
    // @ts-expect-error TS(2339): Property 'retryFailed' does not exist on type 'nev... Remove this comment to see the full error message
    if (artwork?.retryFailed) return "Image upload failed";
    // @ts-expect-error TS(2339): Property 'uploadError' does not exist on type 'nev... Remove this comment to see the full error message
    return validationError() || artwork?.uploadError;
  }

  function upscaleThresholdError() {
    return validationError() === "upscale_threshold_exceeded";
  }

  function errorDimension() {
    if (heightError()) {
      return "7200px tall (24″ at 300 DPI)";
    }
    return "6600px wide (22″ at 300 DPI)";
  }

  function errorDimensionReadable() {
    if (heightError()) {
      return "24″ tall (7200px at 300 DPI)";
    }
    return "22″ wide (6600px at 300 DPI)";
  }

  function setShowGangSheetBuilder(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setShowGangSheetBuilder(...args);
  }

  function handleDtfTransferBySize() {
    submitDtfEvent("try_dtf_transfer_by_size_clicked", {
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      artwork_id: artwork?.id,
      error_message: dimensionErrorMessage()
    });
    redirectTo(gangSheetArtworkProductLink());
  }

  function handleGangSheetBuilder() {
    setShowGangSheetBuilder(true);
    submitDtfEvent("gangsheet_builder_opened", {});
  }

  useEffect(() => {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    if (!artwork?.id) return;

    // @ts-expect-error TS(2339): Property 'retryFailed' does not exist on type 'never'.
    const isUploadError = artwork?.retryFailed || artwork?.uploadError;
    const isValidationError = widthError() || heightError() || upscaleThresholdError();

    let eventName;
    if (isUploadError) {
      eventName = "upload_error_displayed";
    } else if (isValidationError) {
      eventName = "file_validation_error_displayed";
    } else {
      eventName = "processing_error_displayed";
    }

    submitDtfEvent(eventName, {
      error_message: dimensionErrorMessage(),
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      artwork_id: artwork?.id
    });
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
  }, [artwork?.id, artwork?.retryFailed, artwork?.uploadError, artwork?.errorMessage]);

  return (
    <ArtworkAlert
      {...restProps}
      // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
      className={cn("artwork-error scope-edae991e", restProps?.className, {
        "artwork-error--compact": showStepsUI()
      })}
      data-testid="artwork-error"
    >
      {(widthError() || heightError()) && showNewGangSheetErrorMessage() ? (
        <div className="scope-edae991e">
          <div className="artwork-error__readable-container scope-edae991e">
            <div className="scope-edae991e flex">
              <div className="artwork-error__readable-icon scope-edae991e">
                <UseSvg
                  className="artwork-error__warning scope-edae991e"
                  icon="warning-hexagon"
                  data-testid="artwork-error-warning"
                />
              </div>
              <div className="scope-edae991e content-center">
                {" "}
                Upload a {errorDimensionReadable()}, or try our{" "}
                <a
                  className="artwork-dimensions__link-to-dtf-artwork artwork-error__link scope-edae991e"
                  onClick={e => {
                    e.stopPropagation();
                    handleGangSheetBuilder();
                  }}
                  data-testid="artwork-dimensions-link-to-dtf-artwork"
                >
                  {" "}
                  Gang Sheet Builder{" "}
                </a>{" "}
                for easy design layout.{" "}
              </div>
            </div>
            <div className="scope-edae991e">
              <div className="artwork-error__readable-text scope-edae991e">
                Uploaded a single design?
              </div>
              <button
                className="artwork-error__button-try-dtf-transfer-by-size scope-edae991e"
                type="button"
                onClick={e => {
                  e.stopPropagation();
                  handleDtfTransferBySize();
                }}
                data-testid="artwork-error-button-try-dtf-transfer-by-size"
              >
                {" "}
                Try DTF Transfers by Size{" "}
              </button>
            </div>
          </div>
        </div>
      ) : widthError() || heightError() ? (
        <div className="scope-edae991e">
          <b className="scope-edae991e">The artwork must be {errorDimension()}.</b>
          <br className="scope-edae991e" /> Please take a look at our{" "}
          <a
            className="artwork-dimensions__link-to-dtf-artwork scope-edae991e"
            // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'string |... Remove this comment to see the full error message
            href={dpiInstructionsUrl()}
            data-testid="artwork-dimensions-link-to-dtf-artwork-1"
          >
            {" "}
            Artwork DPI guide{" "}
          </a>{" "}
          for more info.{" "}
        </div>
      ) : upscaleThresholdError() ? (
        <div className="scope-edae991e">
          {" "}
          The uploaded image will not print clearly at this size. Reduce your image size, or click{" "}
          <a
            className="artwork-dimensions__error-message-link scope-edae991e"
            // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'string |... Remove this comment to see the full error message
            href={dpiInstructionsUrl()}
            target="_blank"
            data-testid="artwork-dimensions-error-message-link"
            rel="noreferrer"
          >
            {" "}
            here{" "}
          </a>{" "}
          to learn how you can fix this.{" "}
        </div>
      ) : (
        <div className="scope-edae991e">
          <p
            className="artwork-error__generic-error-message scope-edae991e"
            dangerouslySetInnerHTML={{ __html: dimensionErrorMessage() }}
          />
        </div>
      )}
    </ArtworkAlert>
  );
}
